/**
 * Defines the static path and indexability of all routes in the application.
 * This file should have no component imports to ensure it can be safely
 * imported into build scripts and configuration files.
 */

type ChangeFreq = 'always' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly' | 'never';

interface RouteDefinition {
  path: string;
  indexable: boolean;
  priority?: number;
  changefreq?: ChangeFreq;
}

export const routeDefinitions: { [key: string]: RouteDefinition } = {
  HOME: { path: '/', indexable: true, priority: 1.0, changefreq: 'daily' },
  DOCUMENT_READ: { path: '/document/:identityKey', indexable: false },
  LOCAL_VOCABULARY: { path: '/local-vocabulary', indexable: false },
  HISTORY: { path: '/history', indexable: false },
  LOGIN: { path: '/login', indexable: false },
  REGISTER: { path: '/register', indexable: false },
  PROFILE: { path: '/profile', indexable: false },
  FORGOT_PASSWORD: { path: '/forgot-password', indexable: false },
  RESET_PASSWORD: { path: '/reset-password', indexable: false },
  PRICING: { path: '/pricing', indexable: true, priority: 0.9, changefreq: 'monthly' },
  AUTH_CALLBACK: { path: '/auth/callback', indexable: false },
  PAYMENT_SUCCESS: { path: '/payment/success', indexable: false },
  PAYMENT_CANCEL: { path: '/payment/cancel', indexable: false },
  TERMS_OF_SERVICE: { path: '/terms', indexable: true, priority: 0.6, changefreq: 'yearly' },
  PRIVACY_POLICY: { path: '/privacy', indexable: true, priority: 0.6, changefreq: 'yearly' },
  NOT_FOUND: { path: '*', indexable: false },
};
